import axios from 'axios'
import { sendSNSMessage } from '../utils/functions'

const odataUrl =
  (process.env.REACT_APP_BUILD_ENV || 'development') === 'development' ?
    'https://dev-coreapi.qallix.com/odata'
  : 'https://coreapi.qallix.com/odata'
const merchantUrl =
  (process.env.REACT_APP_BUILD_ENV || 'development') === 'development' ?
    'https://dev-merchantapi.qallix.com/api'
  : 'https://merchantapi.qallix.com/api'
const analyticsUrl =
  (process.env.REACT_APP_BUILD_ENV || 'development') === 'development' ?
    'https://dev-analytics.qallix.com/api'
  : 'https://analytics.qallix.com/api'

const apiUrl = 'https://api.qallix.com'

const odataAxios = axios.create({
  baseURL: odataUrl,
})

const merchantAxios = axios.create({
  baseURL: merchantUrl,
})

const analyticsAxios = axios.create({
  baseURL: analyticsUrl,
})

const qallixApiAxios = axios.create({
  baseURL: apiUrl,
})

const handleError = (error) => {
  if ((process.env.REACT_APP_BUILD_ENV || 'development') !== 'development') {
    let errorMessage = JSON.stringify({
      url: `${error?.config?.baseURL ?? ''}${error?.config?.url ?? ''}`,
      payload: error?.config?.data ?? '',
      message: error?.message ?? '',
      orgUser: window?.localStorage?.getItem('orgUser') ?? '',
    })
    sendSNSMessage(errorMessage)
  }
  throw error
}

const insertOrgIdAsHeader = (config) => {
  try {
    const orgUserString = window?.localStorage?.getItem('orgUser')
    const orgUser = JSON.parse(orgUserString)
    config.headers.OrgId = orgUser?.orgId ?? 0
  } catch {
    config.headers.OrgId = 0
  }
  return config
}

//Send OrgId as header
odataAxios.interceptors.request.use((config) => {
  return insertOrgIdAsHeader(config)
})
merchantAxios.interceptors.request.use((config) => {
  return insertOrgIdAsHeader(config)
})
qallixApiAxios.interceptors.request.use((config) => {
  return insertOrgIdAsHeader(config)
})
qallixApiAxios.interceptors.request.use((config) => {
  return insertOrgIdAsHeader(config)
})

//Error Handling
odataAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleError(error)
  },
)

merchantAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleError(error)
  },
)

analyticsAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleError(error)
  },
)

qallixApiAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleError(error)
  },
)

export { odataAxios, merchantAxios, analyticsAxios, qallixApiAxios }
